import React from "react";
import Datatable from "../../../../core/common/dataTable";
import AssetHistoryModal from "../../assign-asset/components/assetHistoryModal";

const QuickInfoModal = ({
  title,
  dataSource,
  columns,
  selectedHistoryAsset,
}: any) => {

  return (
    <>
      <div className="modal fade p-2" id="asset-stats-info-modal" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content p-3">
            <div className="modal-header">
              <h4 className="modal-title">{title || "List"}</h4>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                data-bs-dismiss="modal"></button>
            </div>
            <div className="card-body p-0">
              <Datatable
                key={JSON.stringify(dataSource)}
                dataSource={dataSource}
                columns={columns}
              />
            </div>
            <div className="modal-footer border-top">
              <button
                type="button"
                className="btn btn-primary btn-sm me-2"
                data-bs-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <AssetHistoryModal
        assetId={selectedHistoryAsset?.asset_id}
        assetName={selectedHistoryAsset?.product_name}
        selectedHistoryAsset={selectedHistoryAsset}
      />
    </>
  );
};

export default QuickInfoModal;
